var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-support-staff-modal-root"},[(_vm.isOpen)?_c('AdminSupportStaffModal',{attrs:{"security":_vm.activeSecurity},on:{"verified":_vm.onVerified,"cancel":_vm.onCancel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }